import { CatalogueNavigationProvider } from '@/services/catalogue/validation/CatalogueNavigationService';
import { FC, PropsWithChildren } from 'react';
import { useParams } from 'react-router';
import { BundleProvider } from '../../services/bundles/BundleService';

export const CustomerCatalogueContainer: FC<PropsWithChildren> = ({ children }) => {
  const { companyId, partnerId } = useParams();

  if (!companyId || !partnerId) throw new Error('Missing companyId or partnerId');

  return (
    <BundleProvider customerId={companyId} mspId={partnerId}>
      <CatalogueNavigationProvider>
        <div className="flex flex-1 overflow-hidden">{children}</div>
      </CatalogueNavigationProvider>
    </BundleProvider>
  );
};
